import { render, staticRenderFns } from "./StudentCreateTabSocialLinks.vue?vue&type=template&id=7fced30c&scoped=true&"
import script from "./StudentCreateTabSocialLinks.vue?vue&type=script&lang=js&"
export * from "./StudentCreateTabSocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./StudentCreateTabSocialLinks.vue?vue&type=style&index=0&id=7fced30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fced30c",
  null
  
)

export default component.exports